export const LEAVE_CODE_331_ID = 29;
export const LEAVE_CODE_111_ID = 1;
export const LEAVE_CODE_URL_WYP_ID = 34;

export const LEAVE_CODE_151_ID = 4;
export const LEAVE_CODE_152_ID = 5;
export const LEAVE_CODE_ART188_ID = 35;
export const LEAVE_CODE_ART148_ID = 37;

export const LEAVE_CODE_VACATION_DAYS_IDS = [LEAVE_CODE_111_ID, LEAVE_CODE_151_ID, LEAVE_CODE_152_ID, LEAVE_CODE_URL_WYP_ID, LEAVE_CODE_ART148_ID, LEAVE_CODE_ART188_ID];

export default {
  LEAVE_CODE_331_ID,
  LEAVE_CODE_111_ID,
  LEAVE_CODE_151_ID,
  LEAVE_CODE_152_ID,
  LEAVE_CODE_URL_WYP_ID,
  LEAVE_CODE_ART148_ID,
  LEAVE_CODE_ART188_ID,
};
